import { Row } from '@devexpress/dx-react-grid';
import styled from '@emotion/styled';
import { Container } from 'components/Layout';
import { useMemo } from 'react';
import { NoReportDataMessage } from 'components/ReportsComponents/NoReportDataMessage';
import {
  columns,
  groupSummaryItems,
  summaryItems,
  calculateSelectedRow,
} from './constants';
import { GroupCellContent } from './GroupCellContent';
import { sortReportData } from './helpers/sortReportData';
import { SLAReportTableProps } from './types';
import ReportGridNew from 'components/ReportGrid_New';
import { noPDFexportFormats } from 'components/ReportGrid_New/constants';
import { cellPrepared } from './helpers/cellPrepared';
import { customizeCell } from './helpers/customizeCell';

// TODO: sorting doesn't work
export function SLAReportTable({
  reportData,
  isReportFetching,
  reportHeaderTagLine,
}: Readonly<SLAReportTableProps>) {
  const rows = useMemo<Row>(() => sortReportData(reportData), [reportData]);

  return (
    <>
      {!isReportFetching && rows && rows?.length === 0 && (
        <NoReportDataMessage />
      )}
      <ReportGridContainer direction="column">
        <ReportGridNew
          allowSorting={false}
          calculateSelectedRow={calculateSelectedRow}
          cellPrepared={cellPrepared}
          columns={columns}
          customizeCell={customizeCell}
          exportFormats={noPDFexportFormats}
          groupCellContent={(options) => GroupCellContent(reportData, options,)}
          headerTitleForSheet={"SLA Performance V3 Report"}
          isLoading={isReportFetching}
          reportHeaderTagLine={reportHeaderTagLine}
          rows={rows}
          showFiltering={false}
          showSelection={false}
          summaryItems={summaryItems}
          groupSummaryItems={groupSummaryItems}
          title={"SLAPerformanceV3"}
        />
      </ReportGridContainer>
    </>
  );
}

const ReportGridContainer = styled(Container)`
  padding-left: ${({ theme }) => theme.padding.xl};
  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
    padding: 0 20px;
  }
  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
    padding: 0 15px;
  }
  .Content-columnTitle {
    strong {
      display: none !important;
    }
    white-space: pre-line;
  }
`;
